import React from 'react';
import PropTypes from 'prop-types';
import Popover from './Popover';
import InteractiveGradesMenu from './InteractiveGradesMenu';
import ActivityListOfGrades from './ActivityGradesMenu';
import { INTERACTIVE } from '../../constants';

const ComponentPopper = ({ el, show, onClose, walkableType, ...props }) => {
  const WIDTH = 400;
  const Content = walkableType === INTERACTIVE ? InteractiveGradesMenu : ActivityListOfGrades;

  return (
    <Popover el={el} show={show} onClose={onClose} width={WIDTH}>
      <Content walkableType={walkableType} {...props} />
    </Popover>
  );
};

ComponentPopper.propTypes = {
  el: PropTypes.object,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  studentId: PropTypes.string,
  cohortId: PropTypes.string,
  deploymentId: PropTypes.string,
  walkableType: PropTypes.string,
  walkableId: PropTypes.string,
};

export default ComponentPopper;
